/**
 * Custom PDP Sticky Add-to-Cart Bar  v2.0
 * ============================================================
 * テーマアップデート耐性: 独立JSファイル（Dawn コア無変更）
 *
 * v2.0 改善:
 * - CTAボタンを1つに統合（「カートに入れる」のみ）
 * - バリアントドロップダウン（PC）/ ボトムシート（モバイル）
 * - 在庫ステータス表示
 * - メインフォームとの双方向同期
 * - Caraway Home風ヘッダー直下スライドダウン表示
 * - 成功/エラーフィードバック改善
 * ============================================================
 */

(function () {
  'use strict';

  /* -------------------------------------------------------
     SELECTORS
  ------------------------------------------------------- */
  const SEL = {
    productForm:       'form[action*="/cart/add"]',
    submitButton:      '.product-form__submit',
    variantIdInput:    'input[name="id"]',           // hidden input inside product form
    variantSelects:    'variant-selects, variant-radios', // Dawn custom elements

    stickyDesktop:     '#pdp-sticky-bar-desktop',
    stickyMobile:      '#pdp-sticky-bar-mobile',

    atcDesktop:        '#pdp-sticky-atc-desktop',
    atcMobile:         '#pdp-sticky-atc-mobile',

    variantTriggerDT:  '#pdp-sticky-variant-trigger-desktop',
    variantDropdown:   '#pdp-sticky-variant-dropdown',
    variantLabelDT:    '#pdp-sticky-variant-label-desktop',

    variantTriggerMB:  '#pdp-sticky-variant-trigger-mobile',
    variantLabelMB:    '#pdp-sticky-variant-label-mobile',
    bottomSheet:       '#pdp-bottomsheet',
    bottomSheetOverlay:'#pdp-bottomsheet-overlay',
    bottomSheetClose:  '#pdp-bottomsheet-close',

    priceDesktop:      '#pdp-sticky-price-desktop',
    priceMobile:       '#pdp-sticky-price-mobile',
    compareDesktop:    '#pdp-sticky-compare-desktop',
    stockDesktop:      '#pdp-sticky-stock-desktop',
    thumb:             '#pdp-sticky-thumb',

    variantDataJSON:   '#pdp-sticky-variant-data',
  };

  /* -------------------------------------------------------
     STATE
  ------------------------------------------------------- */
  let variants = [];
  let currentVariantId = null;
  let dropdownOpen = false;
  let bottomSheetOpen = false;

  /* -------------------------------------------------------
     INIT
  ------------------------------------------------------- */
  function init() {
    const productForm = document.querySelector(SEL.productForm);
    if (!productForm) return;

    const stickyDesktop = document.querySelector(SEL.stickyDesktop);
    const stickyMobile = document.querySelector(SEL.stickyMobile);
    if (!stickyDesktop && !stickyMobile) return;

    // Load variant data
    const dataEl = document.querySelector(SEL.variantDataJSON);
    if (dataEl) {
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { /* no-op */ }
    }

    // Get initial variant ID from form
    const idInput = productForm.querySelector(SEL.variantIdInput);
    if (idInput) currentVariantId = parseInt(idInput.value, 10);

    // ------ Force Dawn header to ALWAYS-STICKY mode ------
    forceDawnHeaderAlwaysSticky();

    // ------ Scroll-based sticky bar trigger + header positioning ------
    initStickyScroll(productForm, stickyDesktop, stickyMobile);

    // ------ ATC click handlers ------
    initAtcHandlers(productForm);

    // ------ Variant selector (Desktop dropdown) ------
    initDesktopVariantDropdown(productForm);

    // ------ Variant selector (Mobile bottom sheet) ------
    initMobileBottomSheet(productForm);

    // ------ Bidirectional sync with main form ------
    initFormSync(productForm);
  }

  /* -------------------------------------------------------
     FORCE DAWN HEADER ALWAYS-STICKY
     Dawn の StickyHeader カスタム要素の内部プロパティを上書きし、
     スクロールダウンでもヘッダーを隠さないようにする。
     Dawn コアファイル変更不要。
  ------------------------------------------------------- */
  function forceDawnHeaderAlwaysSticky() {
    const stickyHeaderEl = document.querySelector('sticky-header');
    if (!stickyHeaderEl) return;

    // Dawn StickyHeader の hide()/reveal()/reset() は
    // headerIsAlwaysSticky === true の場合 early return する。
    // この値を外部から true に上書きすることで、
    // ヘッダーが常時表示される。
    stickyHeaderEl.headerIsAlwaysSticky = true;

    // ヘッダーに常時 sticky クラスを付与
    const header = document.querySelector('.section-header');
    if (header) {
      header.classList.add('shopify-section-header-sticky');
      header.classList.remove('shopify-section-header-hidden');
    }
  }

  /* -------------------------------------------------------
     SCROLL-BASED STICKY TRIGGER + HEADER POSITIONING
     submit ボタンの位置を直接チェック。
     top は常に headerHeight に設定し、表示/非表示は
     transform のみで制御。これにより CSS transition の
     「ヌルっと」アニメーションが正しく動作する。
  ------------------------------------------------------- */
  function initStickyScroll(productForm, stickyDesktop, stickyMobile) {
    const header = document.querySelector('.section-header');
    let isBarShowing = false;
    let rafId = null;

    // Observe target: the submit button (small element = responsive trigger)
    const triggerEl = productForm.querySelector(SEL.submitButton) || productForm;

    // top を常に headerHeight にセット（hidden 状態でも）
    // hidden 時は transform: translateY(-100%) でバー自身の高さ分
    // 上にずれるので、ヘッダーの裏に隠れる。
    // visible になると transform: translateY(0) にアニメーションし、
    // ヘッダー直下からヌルっと出現する。
    function syncTop() {
      if (!header) return;
      const h = header.offsetHeight + 'px';
      if (stickyDesktop) stickyDesktop.style.top = h;
      if (stickyMobile) stickyMobile.style.top = h;
    }

    function check() {
      const rect = triggerEl.getBoundingClientRect();
      const headerHeight = header ? header.offsetHeight : 0;

      // submit ボタンがヘッダーの裏に隠れたら sticky bar を表示
      const shouldShow = rect.bottom < headerHeight;

      // top は常に headerHeight に同期（表示状態に関係なく）
      syncTop();

      if (shouldShow !== isBarShowing) {
        isBarShowing = shouldShow;

        if (stickyDesktop) {
          stickyDesktop.classList.toggle('is-visible', shouldShow);
        }
        if (stickyMobile) {
          stickyMobile.classList.toggle('is-visible', shouldShow);
        }
        document.body.classList.toggle('pdp-has-sticky-bar', shouldShow);
      }

      rafId = null;
    }

    function onScroll() {
      if (!rafId) {
        rafId = requestAnimationFrame(check);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Also update on resize (header height may change)
    window.addEventListener('resize', () => {
      if (!rafId) rafId = requestAnimationFrame(check);
    }, { passive: true });

    // Initial setup
    syncTop();
    check();
  }

  /* -------------------------------------------------------
     ATC HANDLERS — ネイティブ Dawn <product-form> へ委譲
     独自 /cart/add.js fetch はバリアントID取得・数量・在庫切れで
     不具合(間欠失敗)が出るため使わず、「カートに追加する」を発火する。
  ------------------------------------------------------- */
  function initAtcHandlers(productForm) {
    function nativeAddButton() {
      return document.querySelector('product-form [name="add"]');
    }

    // 楽観的UI: クリック直後に「保存しました」+緑+カート数を即時表示し、追加は裏でネイティブが実行。失敗時のみ戻す。
    function bumpCartCount(delta) {
      document.querySelectorAll('.cart-count-bubble [aria-hidden="true"]').forEach((el) => {
        const n = parseInt(el.textContent, 10) || 0;
        el.textContent = Math.max(0, n + delta);
      });
    }
    function getQty() {
      const f = document.querySelector('product-form form') || document.querySelector('form[action*="/cart/add"]');
      const q = f && f.querySelector('[name="quantity"]');
      return q ? (parseInt(q.value, 10) || 1) : 1;
    }
    function armCartFeedback(btn, savedText, qty) {
      if (btn.dataset.cpdpBusy) return;
      btn.dataset.cpdpBusy = '1';
      const textEl = btn.querySelector('.pdp-amazon-atc__text') || btn;
      const origText = textEl.textContent;
      btn.classList.add('is-success');
      textEl.textContent = savedText;
      bumpCartCount(qty);
      const revertText = () => { btn.classList.remove('is-success'); textEl.textContent = origText; delete btn.dataset.cpdpBusy; };
      if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') { setTimeout(revertText, 2500); return; }
      let done = false, unU, unE, timer;
      const cleanup = () => { if (unU) unU(); if (unE) unE(); clearTimeout(timer); };
      unU = subscribe(PUB_SUB_EVENTS.cartUpdate, () => { if (done) return; done = true; cleanup(); setTimeout(revertText, 2500); });
      unE = subscribe(PUB_SUB_EVENTS.cartError, () => { if (done) return; done = true; cleanup(); bumpCartCount(-qty); revertText(); });
      timer = setTimeout(() => { if (!done) { done = true; cleanup(); revertText(); } }, 8000);
    }

    // スティッキーバーの「カートに入れる」(PC / モバイル)
    [SEL.atcDesktop, SEL.atcMobile].forEach((sel) => {
      const btn = document.querySelector(sel);
      if (!btn) return;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (btn.disabled || btn.classList.contains('is-loading')) return;
        const add = nativeAddButton();
        if (!add || add.disabled) return;
        armCartFeedback(btn, '✓ カートに保存しました', getQty());
        add.click();
      });
    });

    // 商品説明内のCTAボタン (.js-desc-atc)
    document.querySelectorAll('.js-desc-atc').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const add = nativeAddButton();
        if (!add || add.disabled) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }
        armCartFeedback(btn, '✓ カートに保存しました', getQty());
        add.click();
      });
    });
  }

  /* -------------------------------------------------------
     CART COUNT UPDATE — ヘッダーのカートアイコン数を更新
  ------------------------------------------------------- */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
      .then((res) => res.json())
      .then((cart) => {
        // Dawn のカート数バブルを更新
        const bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach((bubble) => {
          const countEl = bubble.querySelector('[aria-hidden="true"]');
          if (countEl) countEl.textContent = cart.item_count;
          const srEl = bubble.querySelector('.visually-hidden');
          if (srEl) srEl.textContent = cart.item_count + ' items';
        });

        // カートアイコンの空/非空切り替え
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon && cart.item_count > 0) {
          const emptySvg = cartIcon.querySelector('.icon-cart-empty');
          const fullSvg = cartIcon.querySelector('.icon-cart');
          if (emptySvg) emptySvg.closest('.svg-wrapper').style.display = 'none';
          if (fullSvg) fullSvg.closest('.svg-wrapper').style.display = '';

          // バブルがなければ作成
          if (!cartIcon.querySelector('.cart-count-bubble')) {
            const bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            bubble.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
            cartIcon.appendChild(bubble);
          }
        }
      })
      .catch(() => { /* silent fail */ });
  }

  /* -------------------------------------------------------
     DAWN CART DRAWER / NOTIFICATION TRIGGER
  ------------------------------------------------------- */
  function triggerDawnCartUpdate() {
    // Dawn の cart-notification / cart-drawer を更新
    // Section Rendering API でカート関連セクションを再取得
    const sectionId = document.querySelector('cart-notification')
      ? 'cart-notification'
      : document.querySelector('cart-drawer')
        ? 'cart-drawer'
        : null;

    if (sectionId) {
      fetch('/?sections=' + sectionId)
        .then((res) => res.json())
        .then((sections) => {
          const html = sections[sectionId];
          if (html) {
            const el = document.querySelector(sectionId);
            if (el) {
              el.innerHTML = new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector(sectionId).innerHTML;

              // cart-notification を開く
              if (sectionId === 'cart-notification') {
                el.classList.add('animate', 'active');
                el.removeAttribute('hidden');
                setTimeout(() => {
                  el.classList.remove('active');
                  setTimeout(() => {
                    el.classList.remove('animate');
                    el.setAttribute('hidden', '');
                  }, 500);
                }, 3000);
              }
              // cart-drawer を開く
              if (sectionId === 'cart-drawer') {
                const details = el.closest('details') || el.querySelector('details');
                if (details) details.setAttribute('open', '');
              }
            }
          }
        })
        .catch(() => { /* silent fail */ });
    }
  }

  /* -------------------------------------------------------
     DESKTOP VARIANT DROPDOWN
  ------------------------------------------------------- */
  function initDesktopVariantDropdown(productForm) {
    const trigger = document.querySelector(SEL.variantTriggerDT);
    const dropdown = document.querySelector(SEL.variantDropdown);
    if (!trigger || !dropdown) return;

    // Toggle dropdown
    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      dropdownOpen = !dropdownOpen;
      dropdown.classList.toggle('is-open', dropdownOpen);
      trigger.setAttribute('aria-expanded', dropdownOpen);
    });

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (dropdownOpen && !dropdown.contains(e.target) && !trigger.contains(e.target)) {
        dropdownOpen = false;
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
      }
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && dropdownOpen) {
        dropdownOpen = false;
        dropdown.classList.remove('is-open');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });

    // Variant option click
    dropdown.querySelectorAll('[data-variant-id]').forEach((opt) => {
      opt.addEventListener('click', () => {
        const variantId = parseInt(opt.dataset.variantId, 10);
        selectVariant(variantId, productForm);

        // Close dropdown after short delay
        setTimeout(() => {
          dropdownOpen = false;
          dropdown.classList.remove('is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }, 200);
      });
    });
  }

  /* -------------------------------------------------------
     MOBILE BOTTOM SHEET
  ------------------------------------------------------- */
  function initMobileBottomSheet(productForm) {
    const trigger = document.querySelector(SEL.variantTriggerMB);
    const sheet = document.querySelector(SEL.bottomSheet);
    const overlay = document.querySelector(SEL.bottomSheetOverlay);
    const closeBtn = document.querySelector(SEL.bottomSheetClose);
    if (!trigger || !sheet) return;

    function openSheet() {
      bottomSheetOpen = true;
      sheet.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
      bottomSheetOpen = false;
      sheet.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openSheet);
    if (overlay) overlay.addEventListener('click', closeSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);

    // Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && bottomSheetOpen) closeSheet();
    });

    // Swipe down to close
    let touchStartY = 0;
    sheet.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    sheet.addEventListener('touchend', (e) => {
      const diff = e.changedTouches[0].clientY - touchStartY;
      if (diff > 60) closeSheet();
    }, { passive: true });

    // Option click
    sheet.querySelectorAll('[data-variant-id]').forEach((opt) => {
      opt.addEventListener('click', () => {
        const variantId = parseInt(opt.dataset.variantId, 10);
        selectVariant(variantId, productForm);
        setTimeout(closeSheet, 200);
      });
    });
  }

  /* -------------------------------------------------------
     SELECT VARIANT — update sticky bar + sync main form
  ------------------------------------------------------- */
  function selectVariant(variantId, productForm) {
    currentVariantId = variantId;
    const variant = variants.find((v) => v.id === variantId);
    if (!variant) return;

    // --- Update sticky bar UI ---
    updateStickyBarUI(variant);

    // --- Sync main product form ---
    syncMainForm(variantId, productForm);

    // --- Update URL ---
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url);
  }

  /* -------------------------------------------------------
     UPDATE STICKY BAR UI
  ------------------------------------------------------- */
  function updateStickyBarUI(variant) {
    // Variant labels
    const labelDT = document.querySelector(SEL.variantLabelDT);
    const labelMB = document.querySelector(SEL.variantLabelMB);
    if (labelDT) labelDT.textContent = variant.title;
    if (labelMB) labelMB.textContent = variant.title;

    // Prices
    const priceDT = document.querySelector(SEL.priceDesktop);
    const priceMB = document.querySelector(SEL.priceMobile);
    if (priceDT) priceDT.textContent = variant.priceFormatted;
    if (priceMB) priceMB.textContent = variant.priceFormatted;

    // Compare-at price
    const compareDT = document.querySelector(SEL.compareDesktop);
    if (compareDT) {
      if (variant.compareAtPrice > variant.price) {
        compareDT.textContent = variant.compareAtPriceFormatted;
        compareDT.style.display = '';
      } else {
        compareDT.style.display = 'none';
      }
    }

    // Stock status
    const stockDT = document.querySelector(SEL.stockDesktop);
    if (stockDT) {
      if (!variant.available) {
        stockDT.innerHTML = '<span class="pdp-sticky-bar__stock--out">売り切れ</span>';
      } else if (variant.inventoryQuantity > 0 && variant.inventoryQuantity <= 5) {
        stockDT.innerHTML = '<span class="pdp-sticky-bar__stock--low">残り' + variant.inventoryQuantity + '点</span>';
      } else {
        stockDT.innerHTML = '<span class="pdp-sticky-bar__stock--ok">✓ 在庫あり</span>';
      }
    }

    // Thumbnail
    if (variant.image) {
      const thumb = document.querySelector(SEL.thumb);
      if (thumb) thumb.src = variant.image;
    }

    // ATC button state
    [SEL.atcDesktop, SEL.atcMobile].forEach((sel) => {
      const btn = document.querySelector(sel);
      if (!btn) return;
      btn.disabled = !variant.available;
      const textEl = btn.querySelector('.pdp-amazon-atc__text');
      if (textEl) textEl.textContent = variant.available ? 'カートに入れる' : '売り切れ';
    });

    // Update selected state in dropdown
    const dropdown = document.querySelector(SEL.variantDropdown);
    if (dropdown) {
      dropdown.querySelectorAll('[data-variant-id]').forEach((opt) => {
        const isSelected = parseInt(opt.dataset.variantId, 10) === variant.id;
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected);
        // Update check icon
        const existing = opt.querySelector('.pdp-sticky-bar__check');
        if (existing) existing.innerHTML = isSelected ? '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>' : '';
      });
    }

    // Update selected state in bottom sheet
    const sheet = document.querySelector(SEL.bottomSheet);
    if (sheet) {
      sheet.querySelectorAll('[data-variant-id]').forEach((opt) => {
        const isSelected = parseInt(opt.dataset.variantId, 10) === variant.id;
        opt.classList.toggle('is-selected', isSelected);
        opt.setAttribute('aria-selected', isSelected);
        const check = opt.querySelector('.pdp-bottomsheet__option-check');
        if (check) check.innerHTML = isSelected ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>' : '';
      });
    }
  }

  /* -------------------------------------------------------
     SYNC MAIN FORM — update Dawn's variant selectors
  ------------------------------------------------------- */
  function syncMainForm(variantId, productForm) {
    // Update hidden variant ID input
    const idInput = productForm.querySelector(SEL.variantIdInput);
    if (idInput) idInput.value = variantId;

    // Try to update Dawn's variant-selects / variant-radios
    const variantSelector = document.querySelector(SEL.variantSelects);
    if (variantSelector) {
      // Dawn uses a <select> inside variant-selects
      const selects = variantSelector.querySelectorAll('select');
      const variant = variants.find((v) => v.id === variantId);
      if (variant && selects.length > 0) {
        // For single-option variants, set the first select
        const optionValues = variant.title.split(' / ');
        selects.forEach((select, i) => {
          if (optionValues[i]) {
            select.value = optionValues[i];
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      // Also try radio buttons (variant-radios)
      const radios = variantSelector.querySelectorAll('input[type="radio"]');
      if (variant && radios.length > 0) {
        const optionValues = variant.title.split(' / ');
        optionValues.forEach((val) => {
          radios.forEach((radio) => {
            if (radio.value === val) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
      }
    }
  }

  /* -------------------------------------------------------
     BIDIRECTIONAL SYNC — listen for main form changes
  ------------------------------------------------------- */
  function initFormSync(productForm) {
    // Listen for Dawn's variant change events
    // Dawn dispatches 'change' on variant-selects and updates the hidden input
    const idInput = productForm.querySelector(SEL.variantIdInput);
    if (!idInput) return;

    // Use MutationObserver on the hidden input
    const mo = new MutationObserver(() => {
      const newId = parseInt(idInput.value, 10);
      if (newId && newId !== currentVariantId) {
        currentVariantId = newId;
        const variant = variants.find((v) => v.id === newId);
        if (variant) updateStickyBarUI(variant);
      }
    });
    mo.observe(idInput, { attributes: true, attributeFilter: ['value'] });

    // Also listen for value changes via event
    idInput.addEventListener('change', () => {
      const newId = parseInt(idInput.value, 10);
      if (newId && newId !== currentVariantId) {
        currentVariantId = newId;
        const variant = variants.find((v) => v.id === newId);
        if (variant) updateStickyBarUI(variant);
      }
    });

    // Fallback: periodic check (some Dawn versions update differently)
    setInterval(() => {
      const newId = parseInt(idInput.value, 10);
      if (newId && newId !== currentVariantId) {
        currentVariantId = newId;
        const variant = variants.find((v) => v.id === newId);
        if (variant) updateStickyBarUI(variant);
      }
    }, 500);
  }

  /* -------------------------------------------------------
     BOOTSTRAP
  ------------------------------------------------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify Design Mode re-init
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector(SEL.productForm)) init();
  });
})();
